export default "__VITE_ASSET__CBPTy2DK__"